import { toast } from "react-toastify";
import { wtParseApiCallFailureMessage } from "./ApiWrapper";
// import toastr from "toastr";

export const lzNotifyErrorMessage = (msg) => {

  toast.error(msg, {
    position: "top-right"
  });
}

export const lzNotifySuccessMessage = (msg) => {

  toast.success(msg, {
    position: "top-right"
  });


}

export const lzNotifyErrorMessageFromResult = (res) => {
  const msg = wtParseApiCallFailureMessage(res);
  if (msg !== '') {
    lzNotifyErrorMessage(msg);
  }
}
